import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { DepartmentPage } from '@features/groups/components/pages/DepartmentPage'
import { departmentQueryOptions, groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/department/')({
    component: RouteComponent,
    loader: async ({ context }) => {
        const department = await context.queryClient.ensureQueryData(departmentQueryOptions({ mode: 'my' }))
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'my', identifier: String(department.departmentId), type: 'programme' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load your department'>
            <Suspense fallback={<LoadingIndicator resource='your department' />}>
                <DepartmentPage mode='my' navMode='myDepartment' />
            </Suspense>
        </QueryErrorBoundary>
    )
}
